// Packages

// Components

// Hooks

// Utils

// Types

// Styles
import { ReactNode } from 'react';
import './PageLayout.scss';
import { KiteGrid, KiteGridCell } from '@kite/react-kite';

interface IPageLayoutProps {
  /** Optional custom css class */
  className?: string;
  children: ReactNode;
  pageTitle: string;
  addLeadButton?: boolean;
  eyebrowText?: string;
  renderComponent?: ReactNode;
}

/** Update this description, which will appear in the Storybook documentation */
const PageLayout = ({
  className = '',
  children,
  addLeadButton = false,
  pageTitle,
  renderComponent,
}: IPageLayoutProps) => {
  // ==============================================
  // Hooks/State/Refs
  // ==============================================

  // =============================================
  // Helpers (Memo, CB, vars)
  // =============================================

  // =============================================
  // Interaction Handlers
  // =============================================

  // =============================================
  // Effects
  // =============================================

  // =============================================
  // Return
  // =============================================
  return (
    <KiteGrid className={`page-layout ${className}`}>
      <KiteGridCell col={12}>
        <div className="title-container">
          <div className="title-container__left">
            <h1 className="kite-type-style--title-3">{pageTitle}</h1>
          </div>
          {addLeadButton && renderComponent && (
            <div className="title-container__right">{renderComponent}</div>
          )}
        </div>
      </KiteGridCell>
      <KiteGridCell col={12}>{children}</KiteGridCell>
    </KiteGrid>
  );
};

export default PageLayout;
